import { Injectable } from '@angular/core';
import { createSafeProps } from 'src/lib/tcs-app-insights/app-insights-util';
import { Logger, LoggerOptions } from './logger';
import { AppInsightsLogger } from './app-insights-logger';
import { CacheLoggerCacheService, LogType } from './cache-logger-cache.service';
import { NewRelicLogger } from './new-relic-logger';

/* eslint-disable no-console */
@Injectable()
export class CacheLogger implements Logger {
  constructor(
    private _insightsLogger: AppInsightsLogger,
    private _newRelicLogger: NewRelicLogger,
    private _cacheService: CacheLoggerCacheService,
  ) {}

  public info(message: string, properties?: { [name: string]: string }, options?: LoggerOptions) {
    this._cacheService.cacheItem(LogType.Information, message, properties, options);
  }

  public warning(
    message: string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ) {
    this._cacheService.cacheItem(LogType.Warning, message, properties, options);
  }

  public error(
    error: Error | string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ) {
    let errorStr: string;
    try {
      errorStr =
        typeof error === 'string'
          ? error
          : JSON.stringify(error, Object.getOwnPropertyNames(error));
    } catch (err: any) {
      errorStr = 'error serializing error for cache-logger';
      this._insightsLogger.error(errorStr, createSafeProps({ error: err }));
      this._newRelicLogger.error(errorStr, createSafeProps({ error: err }));
    }
    this._cacheService.cacheItem(LogType.Error, errorStr, properties, options);
  }
}
